import React from 'react';
import { Footer } from '@skf/bt-wind-rail-commonlibrary';
import SkfLogo from '../../../assets/skf-logo-white.svg';

export const FooterLayout: React.FunctionComponent = () => (
  <Footer
    logo={SkfLogo}
  />
);